import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { CreateTag, UpdateTag } from '@trellis/shared'

import { createTag, deleteTag, listTags, updateTag } from '@/requests/tags/index.js'

export function useTagsQuery() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: listTags,
    staleTime: 60_000,
    select: (result) => result.data ?? [],
  })
}

export function useCreateTagMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTag) => createTag(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  })
}

export function useUpdateTagMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTag }) => updateTag(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  })
}

export function useDeleteTagMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteTag(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  })
}
